import { Component, OnInit, OnDestroy } from '@angular/core';
import { StreamService, UserService } from '../services';
import { takeUntil, tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    template: `
        <div *ngIf="noTouching" fxLayoutAlign="center center" style="padding-top: 50px;"><spinner></spinner></div>
        <topic-summary-grid *ngIf="!noTouching" [topics]="topics" emptyMessage="You haven't created topics yet.">
        </topic-summary-grid>
    `
})
export class BrowseAllMyTopicsPaneComponent implements OnInit, OnDestroy {
    noTouching = true;
    private cleanupTime = new Subject<void>();
    topics: any[];

    constructor(private route: ActivatedRoute, 
                private router: Router, 
                private streamService: StreamService, 
                private userService: UserService) {}

    ngOnInit(): void {
        this.route.queryParams.pipe(takeUntil(this.cleanupTime)).subscribe(() => this.populate());
        this.populate();
    }

    populate() {
        this.noTouching = true;
        this.streamService.getTenantStreams({ 
            ownerId: this.userService.getCurrentUser().id,
            includeCatalogs: false,
            published: true,
            rows: 1000,
            type: 'COLLECTION',
            sort: this.route.snapshot.queryParams.sort || 'title',
            sortDirection: this.route.snapshot.queryParams.sortDirection || 'asc'
        })
        .pipe(tap(() => this.noTouching = false))
        .subscribe(userTopicResults => {
            this.topics = userTopicResults.content;
            if (!this.topics.length) {
                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: { isEmpty: 'true' },
                    queryParamsHandling: 'merge'
                });
            }
        });
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
